// extracted by mini-css-extract-plugin
export var downArrow = "_iw-0";
export var infoTooltipIcon = "_iw-3";
export var label = "_iw-1";
export var optionCard = "_iw-4";
export var upArrow = "_iw-2";